export const BUSINESS = {
    name: "Shree Ganesh Financial Service",
    established: "2019",
    phones: ["+91 78610 72065", "+91 63519 94003"],
    phoneTel: ["+917861072065", "+916351994003"],
    whatsapp: "917861072065",
    email: "pavanjadhav176@gmail.com",
    address:
        "63/A/11, Gajrajgiri ni chall-1, Dudheshwar road, Shahibag, Ahmedabad 380004",
    addressShort: "Dudheshwar Road, Shahibag, Ahmedabad",
    mapEmbed:
        "https://www.google.com/maps?q=63/A/11,+Gajrajgiri+ni+chall-1,+Dudheshwar+road,+Shahibag,+Ahmedabad+380004&output=embed",
    mapLink:
        "https://www.google.com/maps/search/?api=1&query=63/A/11,+Gajrajgiri+ni+chall-1,+Dudheshwar+road,+Shahibag,+Ahmedabad+380004",
};

export const waLink = (text = "Hello, I would like to know more about your loan & insurance services.") =>
    `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(text)}`;
